/**
 * 对话框
 * 
 * 使用说明:
 * 
 * this.$alertDialog('积分不足', okCb);
 * 
 * this.$confirmDialog('确认删除？', okCb, cancelCb);
 */
import Component from './dialog.vue'

const Ex = {};

// 注册Toast
Ex.install = function (Vue) {
    // 生成一个Vue的子类
    // 同时这个子类也就是组件
    const Constructor = Vue.extend(Component)
    // 生成一个该子类的实例
    const instance = new Constructor();

    // 将这个实例挂载在我创建的div上
    // 并将此div加入全局挂载点内部
    instance.$mount(instance.$el)
    document.body.appendChild(instance.$el)

    // 通过Vue的原型注册一个方法
    // 让所有实例共享这个方法 
    Vue.prototype.$alertDialog = (content, callback=(btn)=>{}) => {
        instance.alert({
            title: content, content:'', icon: 'warn', btn:'确定', callback
        });
    }

    Vue.prototype.$confirmDialog = (content = '', callback=(btn)=>{}) => {
        instance.confirm({
            title: content, content: '', btns: ['取消', '确定'], callback
        });
    }

    Vue.prototype.$confirmDialogWithOpts = (content, icon='warn',  btns= ['取消', '确定'],callback=(btn)=>{}) => {
        instance.confirm({
            title: content, content: '', icon, btns, callback
        });
    }

    Vue.prototype.$confirmDialogWithTitleAndOpts = (title, content, icon='warn',  btns= ['取消', '确定'],callback=(btn)=>{}) => {
        instance.confirm({
            title: title, content, icon, btns, callback
        });
    }

    Vue.prototype.$agreement = (title, content ,callback=(btn)=>{}) => {
        instance.agreement({
            title: title, content: content, callback
        });
    }
}

export default Ex


// WEBPACK FOOTER //
// ./src/components/global/dialog/index.js